
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import FileUpload from '@/components/file-upload';
import DivSpan from '@/components/DivSpan';
import cusDateTime from '@/components/cusDateTime';
import selectSupply from '@/components/browse/select-supply';

export default {
name: 'book-vehicle',
components: { Grid, GridItem, FileUpload, DivSpan, cusDateTime, selectSupply },
props: ['dataId'],
data() {
return {
index: 1,
baseDto: {
status: '',
billNo: '',
title: '',
opinion: '',
availableDateStartStr: '',
purchaserName: '',
pickupBookCode: '',
transactionOrderNum: '',
supplierMerchantName: '',
clientName: '',
pickupBookDateStartStr: '',
pickupBookDateEndStr: '',
driverName: '',
driverPhone: '',
vehicleCode: '',
vehicleType: '',
driverIdCode: '',
attachment: [],
lineItems: []
}
};
},
methods: {
itemTab(index) {
this.index = index;
if (index !== 'flow') {
this.$emit('changeFlowInfo', false);
} else {
this.$emit('changeFlowInfo', true);
}
},
getBaseDto() {
this.$loadingShow();
this.$get('api/rideHailing/' + this.dataId).then((data) => {
if (data) {
this.baseDto = data;
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},

changeClaim(claimDtDto) {
if (claimDtDto.show) {
this.$set(claimDtDto, 'show', false);
return;
}
this.$set(claimDtDto, 'show', true);
},

selectSupplier() {
this.$refs.personRef.showPop();
},

getPerson(result) {
this.baseDto.purchaserName = result.name;
this.baseDto.purchaserId = result.id;
},

valid() {
if (!this.baseDto.opinion) {
this.$message.error('审批意见必填');
return false;
}
if (this.baseDto.opinion == '2' && !this.baseDto.availableDateStartStr) {
this.$message.error('拒绝时需要重新选择预约日期');
return false;
}
if (!this.baseDto.purchaserName) {
this.$message.error('采购员必填');
return false;
}
return true;
},

formData() {
return this.baseDto;
},
},
mounted() {
if (this.dataId) {
this.getBaseDto();
}
},
watch: {
dataId() {
if (this.dataId) {
this.getBaseDto()
}
}
}
};



// WEBPACK FOOTER //
// ./src/page/supplier/view/book-vehicle.vue